import * as React from "react";
import { Slot } from "src/containers/event/event.types";
import { useSlotBookedOrFull } from "./useSlotBookedOrFull";

interface SlotTypeBadgeProps {
  slot: Slot;
}

export const SlotTypeBadge: React.FC<SlotTypeBadgeProps> = ({ slot }) => {
  const { isBooked, isFull } = useSlotBookedOrFull(slot);

  let badgeText = "Unknown";
  let badgeClass = "badge badge-discreet-info rounded-pill";
  if (isBooked) {
    badgeText = "Not available";
    badgeClass = "badge badge-discreet-secondary rounded-pill";
  } else if (isFull) {
    badgeText = "Full";
    badgeClass = "badge badge-discreet-secondary rounded-pill";
  }

  return (
    <div className="d-flex justify-content-between w-100">
      <span className="fs-16">{slot.type}</span>
      <div className={badgeClass}>{badgeText}</div>
    </div>
  );
};
